import { render, staticRenderFns } from "./view-policy.vue?vue&type=template&id=417a8101&"
import script from "./view-policy.vue?vue&type=script&lang=js&"
export * from "./view-policy.vue?vue&type=script&lang=js&"
import style0 from "./view-policy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports